import React, { useRef, useEffect, useState } from "react";
import { useFormik } from "formik";
import { Button, Spin2, Collapse } from "components";
import { validationSchemaVariant, initialValues } from "../components/common";
import { Main, Payment, Additional, Pricing, Product, VariantInfo, Discord, Telegram } from "../components";
import { toastAlert } from "@paylixecommerce/shared/components";
import { useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useParams } from "react-router";
import { editProduct, getProductByID } from "../../actions";
import includes from "lodash/includes";
import config from "constants/config";
import getCDNLink from "constants/cdn-link";
import { Tooltip } from "@paylixecommerce/shared/components";
import moment from "moment";
import { ChevronUp, ChevronDown } from "../../../../../layouts/dashboard/sidebar/icons/icons/icons";
import useMobile from "../../../../../../../hooks/useMobile";
import ClosePage from "../components/save-close";
import { NotFoundIcon, TipsIcon } from "./product";

import "../components/style.scss";


const EditProduct = ({ isAdmin }) => {

    const [gateways, setGateways] = useState({});
    const [delimiter, setDelimiter] = useState(config.DELIMITER_OPTIONS[0].value);
    const [created, setCreated] = useState(false);
    const isMobile = useMobile();

    const [closeConfirmModal, setShowConfirmModal] = useState(false);

    const [volumeDiscounts, setVolumeDiscounts] = useState([]);
    const [customFields, setCustomFields] = useState([]);
    const [webhooks, setWebhooks] = useState([]);
    const [progress, setProgress] = useState(0);
    const [variants, setVariants] = useState([]);
    const [variantsQuantityError, setVariantsQuantityError] = useState("");
    const [discordServerError, setDiscordServerError] = useState("");
    const [telegramServerError, setTelegramServerError] = useState("");

    const [generalInfo, showGeneralInfo] = useState(true);
    const [pricingInfo, showPricingInfo] = useState(false);
    const [paymentInfo, showPaymentInfo] = useState(false);
    const [variantsInfo, showVariantsInfo] = useState(false);
    const [productInfo, showProductInfo] = useState(false);
    const [discordInfo, showDiscordInfo] = useState(false);
    const [telegramInfo, showTelegramInfo] = useState(false);
    const [additionalInfo, showAdditionalInfo] = useState(false);

	const [initial, setInitialValues] = useState(initialValues);

	const [removedImages, setRemovedImages] = useState([]);
	const [removedFiles, setRemovedFiles] = useState([]);

	const [save, setSave] = useState(false);
	const [loading, setLoading] = useState(true);
	const [product, setProduct] = useState(null);
	const [notFound, setNotFound] = useState(null);
	const { id, name: shopName } = useParams();

    const generalInfoRef = useRef(null);
    const generalInfoScroll = () => {
        setTimeout(() => {
            generalInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const pricingInfoRef = useRef(null);
    const pricingInfoScroll = () => {
        setTimeout(() => {
            pricingInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const paymentInfoRef = useRef(null);
    const paymentInfoScroll = () => {
        setTimeout(() => {
            paymentInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const productInfoRef = useRef(null);
    const productInfoScroll = () => {
        setTimeout(() => {
            productInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const additionalInfoRef = useRef(null);
    const additionalInfoScroll = () => {
        setTimeout(() => {
            additionalInfoRef.current.scrollIntoView({ behavior: 'smooth' })
        }, 500)
    };
    const discordInfoRef = useRef(null);
    const discordInfoScroll = () => {
        setTimeout(() => {
            discordInfoRef.current.scrollIntoView({ behavior: 'smooth' })
        }, 500)
    };
    const telegramInfoRef = useRef(null);
    const telegramInfoScroll = () => {
        setTimeout(() => {
            telegramInfoRef.current.scrollIntoView({ behavior: 'smooth' })
        }, 500)
    };
    const variantsInfoRef = useRef(null);
    const variantsInfoScroll = () => {
        setTimeout(() => {
            variantsInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };


    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {

        if(location.state && location.state.isSerials) {
            showGeneralInfo(false);
            showProductInfo(true);
            productInfoScroll();
        }

    }, [location.state])

    const configs = {
        onUploadProgress: progressEvent => {
            setProgress((progressEvent.loaded / progressEvent.total) * 100);
        }
    }

    const getProduct = () => {
        dispatch(getProductByID(id))
            .then(res => {
                if (res.status === 404) {
                    setProduct(null)
                    setNotFound(true)
                } else {
                    setProduct(res.data.product);
                }
            })
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        if (id) {
            getProduct();
        }
    }, [id])

    useEffect(() => {
        if(variants.length >= 2) {
            setVariantsQuantityError("")
        }
    }, [variants])

    const onSubmit = (values, { setErrors }) => {

        setCreated(true);

        if(values.manuallyWarranty && +values.manuallyWarranty < 900) {
            setErrors({
                manuallyWarranty: "Must be more then 900 seconds"
            });
            return;
        }

        const admin = includes(location.pathname, 'admin');

        let data = {...values};

        data.gateways = Object.keys(gateways).filter(key => gateways[key] && key.trim()).join(',');
        data.custom_fields = JSON.stringify({
            custom_fields: customFields.map(field => ({...field, type: field.type}))
        });
        data.volume_discounts = JSON.stringify({volume_discounts: volumeDiscounts});
        data.price_variants = JSON.stringify(variants);
        data.stock = values.showStock ? data.stock : -1;
        data.subtype = values.subtype || "";
        data.price_discount = +values.price_discount;
        if(!data.price_discount_enabled) {
            data.price_discount = null;
        }

        data.redirect_link = data.redirect_enabled ? (values.redirect_link || "") : "";
        data.delivery_text = data.delivery_text_enabled ? (values.delivery_text || "") : "";
        data.affiliate_revenue_percent = values.affiliate_revenue_percent;

        data.watermark_enabled = values.watermark_enabled;
        data.watermark_text = values.watermark_text;

        delete data.serials;

        if(data.quantity_max === "" || data.quantity_max === 0 || data.quantity_max === 0) {
            data.quantity_max = "0";
        }

        if(data.stock_delimiter === "↵") {
            data.stock_delimiter = "\n"
        }

        let warranty = values.warranty;

        if(values.warranty === "1") {
            warranty = values.manuallyWarranty;
            delete values.manuallyWarranty;
        }

        data.warranty = warranty;

        if(removedImages.length) {
            data.remove_images_uniqids = removedImages;
        }

        if(removedFiles.length) {
            data.remove_files_uniqids = removedFiles;
        }

        data.currency = typeof data.currency === "string" ? data.currency : data.currency.value;

        data.webhooks = webhooks;
        data.unlisted = Boolean(data.unlisted);
        data.private = Boolean(data.private);
        data.block_vpn_proxies = Boolean(data.block_vpn_proxies);
        data.on_hold = Boolean(data.on_hold);
        data.pay_what_you_want = Boolean(+data.pay_what_you_want);
        data.licensing_enabled = Boolean(values.licensing_enabled) || false;

        data.serials_remove_duplicates = values.removeDuplicates;

        data.file = data.file.map(v => {
            if(v.size) {
                return v
            } else {
                return null
            }
        }).filter((i) => i);

        data.image = data.image.map(v => {
            if(v.size) {
                return v
            } else {
                return null
            }
        }).filter((i) => i);

        data.image.forEach(({lastModified}, key) => {
            if(lastModified === data.default_image) {
                data.default_image = key;
            }
        });

        if(!data.default_image && data.default_image !== 0) {
            data.default_image = 0
        }

        if(data.default_image && data.default_image.length > 10) {
            if(data.image_attachments) {
                data.image_attachments.forEach(({ uniqid, cloudflare_image_id }) => {
                    if(data.default_image === cloudflare_image_id) {
                        data.default_image = uniqid;
                    }
                })
            }
        }

        delete data.file_attachment;
        delete data.redirect_enabled;
        delete data.warranty_enabled;
        delete data.tos_enabled;
        delete data.delivery_text_enabled;
        delete data.price_discount_enabled;
        delete data.file_attachment_info;
        delete data.file_attachments;
        delete data.removeDuplicates;
        delete data.affiliate_revenue_enabled;

        delete data.image_attachments;
        delete data.image_attachment;
        delete data.image_attachment_info;

        delete data.feedback;
        delete data.price_conversions;

        data.discord_integration = Boolean(data.discord_integration);

        if(data.discord_integration) {
            data.discord_server_id = data.discord_server_id || "none";
            data.discord_set_role = Boolean(data.discord_set_role);
            data.discord_role_id = data.discord_role_id || "";
            data.discord_remove_role = Boolean(data.discord_remove_role);
            data.discord_optional = Boolean(data.discord_optional);
        } else {
            data.discord_server_id = "none";
            data.discord_set_role = false;
            data.discord_role_id = "";
            data.discord_remove_role = false;
            data.discord_optional = false;
        }

        data.telegram_integration = !!data.telegram_integration;
        if (data.telegram_integration) {
            data.telegram_group_id = data.telegram_group_id || "none";
            data.telegram_optional = !!data.telegram_optional;
        } else {
            data.telegram_group_id = "none";
            data.telegram_optional = false;
        }

        setSave(true);

        return dispatch(editProduct(data, configs))
            .then(res => {
                if (admin) {
                    history.goBack();
                    setProgress(0);
                } else {
                    getProduct();
                    setProgress(0);
                }
                toastAlert('success', res.message);
            })
            .catch(err => {
                toastAlert('error', err ? err.error : "");
                setProgress(0);
            })
            .finally(() => {
                setCreated(false);
                setProgress(0);
            })
    };

    useEffect(() => {

        let isAdmin = window.location.origin.includes('admin');

        if(product && product.type === "INFO_CARD") {
            if(isAdmin) {
                history.push(`/tools/users/${shopName}/products/edit/info/${product.uniqid}`);
            } else {
                history.push(`/products/edit/info/${product.uniqid}`);
            }
            return;
        }

        if(product && !product.price_variants) {
            if(isAdmin) {
                history.push(`/tools/users/${shopName}/products/edit/${product.uniqid}`);
            } else {
                history.push(`/products/edit/${product.uniqid}`);
            }
            return;
        }

        if(product) {
            let gateways = {};
            let custom_fields = [];

            let volume_discounts = [];

            if(product && product.volume_discounts) {
                try {
                    volume_discounts = JSON.parse(product.volume_discounts).volume_discounts;
                } catch (e) {}
            }

            let price_variants = [];

            if (product && product.price_variants && product.price_variants.length) {
                price_variants = product.price_variants;

                if (product.type === "SERIALS") {
                    price_variants = price_variants.map((data) => {
                        return {
                            ...data,
                            serials: data.serials && data.serials.length ? data.serials.join(product.stock_delimiter) : ""
                        }
                    })
                } else {
                    price_variants = price_variants.map((data) => {
                        return {
                            ...data,
                            serials: ""
                        }
                    })
                }
            }

            if(product && product.custom_fields) {
                try {
                    custom_fields = JSON.parse(product.custom_fields).custom_fields;
                } catch (e) {}
            }


            let type = config.TYPE_OPTIONS.filter(type => type.value === product.type);

            custom_fields = custom_fields.map(field => {
                let c_type = config.CUSTOM_TYPE.filter(type => type.value === field.type);
                return {...field, type: c_type[0] || "text"}
            });

            let options = product.gateways.split(',').filter(g => g && g.trim());

            if(options.length) {

                options = options
                    .map(g => g.split(":")[0])
                    .filter((g, index, self) => self.indexOf(g) === index);

                if(options.some(g => g.includes("USDC"))) {
                    gateways["USDC"] = true;
                }
                if(options.some(g => g.includes("USDC_NATIVE"))) {
                    gateways["USDC_NATIVE"] = true;
                }
                if(options.some(g => g.includes("USDT"))) {
                    gateways["USDT"] = true;
                }
                if(options.some(g => g.includes("PLZ"))) {
                    gateways["PLZ"] = true;
                }
                if(options.some(g => g.includes("SHIB"))) {
                    gateways["SHIB"] = true;
                }
                if(options.some(g => g.includes("DAI"))) {
                    gateways["DAI"] = true;
                }
                if(options.some(g => g.includes("APE"))) {
                    gateways["APE"] = true;
                }
                if(options.some(g => g.includes("PEPE"))) {
                    gateways["PEPE"] = true;
                }
                if(options.some(g => g.includes("WETH"))) {
                    gateways["WETH"] = true;
                }
                options.map(key => gateways[key] = true);
            }

            let delimiter = product.stock_delimiter === ',' ?
                config.DELIMITER_OPTIONS[0] :
                product.stock_delimiter === '\n' ?
                    config.DELIMITER_OPTIONS[1] :
                    escape(product.stock_delimiter) === '%0D%0A' ?
                        config.DELIMITER_OPTIONS[1] :
                        config.DELIMITER_OPTIONS[2];

            if(escape(product.stock_delimiter) === "%0D%0A") {
                product.stock_delimiter = '\n'
            }

            product.price = product.price_display;

            if(product.warranty === null) {
                product.warranty = '0'
            }

            let warranty = config.WARRANTY_OPTIONS.find(({ value }) => value === product.warranty.toString());


            let file = () => {
                if(product.file_attachments && product.file_attachments.length) {
                    return product.file_attachments.map(i => ({
                        id: i.uniqid,
                        size: i.size ? i.size : null,
                        name: i.original_name,
                        uniqid: i.uniqid
                    }))
                } else {
                    return [];
                }
            };

            let image = () => {

                if(product.image_attachments && product.image_attachments.length) {
                    return product.image_attachments.map(i => ({
                        preview: i.cloudflare_image_id ? getCDNLink({ id: i.cloudflare_image_id, type: "shopItem" }) : null,
                        size: i.size ? i.size : null,
                        date: i.created_at ? moment(i.created_at * 1000).format('DD, MMM YYYY HH:mm') : null,
                        name: i.original_name ? i.original_name : '',
                        uniqid: i.uniqid
                    }))
                } else {
                    return [];
                }
            }

            setInitialValues({
                ...product,
                block_vpn_proxies: !!+product.block_vpn_proxies,
                discord_optional: !!+product.discord_optional,
                discord_server_id: product.discord_server_id || "none",
                telegram_optional: !!+product.telegram_optional,
                telegram_group_id: product.telegram_group_id || "none",
                slug: product.slug || product.uniqid,
                max_risk_level: product.max_risk_level || 85,
                removeDuplicates: product.licensing_enabled,
                default_image: product.image_attachment || "",
                redirect_link: product.redirect_link || "",
                youtube_link: product.youtube_link || "",
                price_discount_enabled: +product.price_discount > 0,
                price_discount: +product.price_discount,
                currency: Object.values(config.CURRENCY_OPTIONS).find(({ key }) => key === product.currency)?.key ?? null,
                warranty: product.warranty.toString() && warranty ? warranty.value.toString() : "1",
                manuallyWarranty: product.warranty.toString() && !warranty ? product.warranty.toString() : null,
                terms_of_service: product.terms_of_service || "",
                label_singular: product.label_singular || "",
                label_plural: product.label_plural || "",
                tos_enabled: !!product.terms_of_service,
                type: type[0].value,
                showStock: product.stock !== -1,
                subtype: product.subtype,
                watermark_enabled: product.watermark_enabled,
                redirect_enabled: product.redirect_link,
                warranty_enabled: (product.warranty.toString() && warranty) || (product.warranty.toString() && !warranty),
                delivery_text_enabled: product.delivery_text,
                watermark_text: product.watermark_text,
                affiliate_revenue_enabled: product.affiliate_revenue_percent > 0,
                affiliate_revenue_percent: product.affiliate_revenue_percent,
                file: file(),
                image: image(),
                recurring_interval: product.recurring_interval || "DAY",
                recurring_interval_count: product.recurring_interval_count || 7
            });

            setDelimiter(delimiter.value)
            setGateways(gateways)
            setCustomFields(custom_fields)
            setVariants(price_variants)
            setVolumeDiscounts(volume_discounts)
            setWebhooks(product.webhooks)

        }

    }, [product, shopName]);

    let form = useFormik({
        validationSchema: validationSchemaVariant,
        enableReinitialize: true,
        initialValues: initial,
        onSubmit
    });


    useEffect(() => {
        if(form.values.discord_server_id && form.values.discord_server_id !== "none") {
            setDiscordServerError("");
        }
    }, [form.values.discord_server_id]);

    useEffect(() => {
        if(form.values.telegram_group_id && form.values.telegram_group_id !== "none") {
            setTelegramServerError("");
        }
    }, [form.values.telegram_group_id]);

    if(notFound) {
        return <>
            <div className="edit-modal-body d-flex align-items-center justify-content-center flex-column">

                <NotFoundIcon />
                <div style={{ fontSize: 24, fontWeight: 600, color: "var(--black9)" }} className="mt-3 mb-2">Product Not Found</div>
                <div style={{ fontSize: 14, color: "var(--black9)" }}>The product with ID <span style={{ fontWeight: 500 }}>{id}</span> could not be found.</div>

            </div>

            <div className="edit-modal-footer">
                <Button type="button" size="large" variant="secondary" className="w-100" onClick={() => history.push(isAdmin ? isAdmin : '/products')}>
                    Close
                </Button>
            </div>
        </>
    }

    return <>

        <div className="edit-modal-header" style={{ borderBottom: "none" }}>
            <div className="edit-modal-header-title">Edit Product with Variants</div>
            <div className="edit-modal-header-ref">/{form.values.slug}</div>
        </div>

        <div className="edit-modal-body">

            <form onSubmit={form.handleSubmit} className="product-form mb-0">

                <div className="product-progress" style={{ width: `${progress}%`}} />

                <div className="product-block">
                    <div className="product-block-header"
                         ref={generalInfoRef}
                         onClick={() => {
                             if (isMobile) {
                                 showGeneralInfo(true)
                                 showPricingInfo(false);
                                 showProductInfo(false);
                                 showPaymentInfo(false);
								 showVariantsInfo(false);
                                 showAdditionalInfo(false);
                                 showDiscordInfo(false);
                                 showTelegramInfo(false);
                             }
                             if(!generalInfo) {
                                 generalInfoScroll();
                             }
                             showGeneralInfo(!generalInfo);
                         }}
                    >
                        <div className="d-flex">
                            {generalInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>General Info</span>
                        </div>
                    </div>

                    <Collapse isOpen={generalInfo}>
                        <Main isVariant form={form} removeImage={(id) => setRemovedImages([...removedImages, id])}/>
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={productInfoRef}
                         onClick={() => {
                             if (isMobile) {
                                 showGeneralInfo(false);
                                 showPricingInfo(false);
                                 showProductInfo(true);
                                 showPaymentInfo(false);
								 showVariantsInfo(false);
                                 showAdditionalInfo(false);
                                 showDiscordInfo(false);
                                 showTelegramInfo(false);
                             }
                             if(!productInfo) {
                                 productInfoScroll();
                             }
                             showProductInfo(!productInfo);
                         }}
                    >
                        <div className="d-flex">
                            {productInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Product</span>
                        </div>
                    </div>
                    <Collapse isOpen={productInfo}>
                        <Product isVariant form={form} setDelimiter={setDelimiter} delimiter={delimiter} removeFile={(id) => setRemovedFiles([...removedFiles, id])} />
                    </Collapse>
                </div>


                <div className="product-block">
                    <div className="product-block-header"
                         ref={variantsInfoRef}
                         onClick={() => {
                             if(isMobile) {
                                 showGeneralInfo(false);
                                 showPricingInfo(false);
                                 showPaymentInfo(false);
								 showProductInfo(false);
								 showVariantsInfo(true);
                                 showAdditionalInfo(false);
                                 showDiscordInfo(false);
                                 showTelegramInfo(false);
                             }
                             if(!variantsInfo) {
								 variantsInfoScroll();
                             }
							 showVariantsInfo(!variantsInfo);
                         }}
                    >
                        <div className="d-flex">
                            {variantsInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Variants</span>
                        </div>
                    </div>
                    <Collapse isOpen={variantsInfo}>
                        <VariantInfo setDelimiter={setDelimiter} variantsQuantityError={variantsQuantityError} isVariant form={form} variants={variants} setVariants={setVariants} />
                    </Collapse>
                </div>


                <div className="product-block">
                    <div className="product-block-header"
                         ref={pricingInfoRef}
                         onClick={() => {
                             if (isMobile) {
                                 showGeneralInfo(false);
                                 showProductInfo(false);
                                 showPaymentInfo(false);
                                 showAdditionalInfo(false);
								 showPricingInfo(true);
								 showVariantsInfo(false);
                                 showDiscordInfo(false);
                                 showTelegramInfo(false);
                             }

                             if (!pricingInfo) {
                                 pricingInfoScroll();
                             }

                             showPricingInfo(!pricingInfo);
                         }}
                    >
                        <div className="d-flex">
                            {pricingInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Pricing</span>
                        </div>
                    </div>
                    <Collapse isOpen={pricingInfo}>
                        <Pricing isVariant form={form}/>
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={paymentInfoRef}
                         onClick={() => {
                             if(isMobile) {
                                 showGeneralInfo(false);
                                 showPricingInfo(false);
								 showProductInfo(false);
								 showVariantsInfo(false);
								 showPaymentInfo(true);
                                 showAdditionalInfo(false);
                                 showDiscordInfo(false);
                                 showTelegramInfo(false);
                             }
                             if(!paymentInfo) {
                                 paymentInfoScroll();
                             }
                             showPaymentInfo(!paymentInfo);
                         }}
                    >
                        <div className="d-flex">
                            {paymentInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Payment Methods</span>
                        </div>
                    </div>
                    <Collapse isOpen={paymentInfo}>
                        <div className="product-form-main-back pb-0">
                            <Payment setGateways={setGateways} gateways={gateways} />
                        </div>
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={discordInfoRef}
                         onClick={() => {
                             if(isMobile) {
                                 showGeneralInfo(false);
                                 showPricingInfo(false);
                                 showProductInfo(false);
                                 showVariantsInfo(false);
                                 showPaymentInfo(false);
                                 showAdditionalInfo(false);
                                 showDiscordInfo(false);
                                 showTelegramInfo(false);
                             }
                             if(!discordInfo) {
								discordInfoScroll();
                             }
                             showDiscordInfo(!discordInfo);
                         }}
                    >
                        <div className="d-flex">
                            {discordInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Discord Integration</span>
                        </div>

                        <div className="product-block-header-optional">Optional</div>
                    </div>
                    <Collapse isOpen={discordInfo}>
                        <Discord discordServerError={discordServerError} form={form} />
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={telegramInfoRef}
                         onClick={() => {
                             if(isMobile) {
                                 showGeneralInfo(false);
                                 showPricingInfo(false);
                                 showProductInfo(false);
                                 showVariantsInfo(false);
                                 showPaymentInfo(false);
                                 showAdditionalInfo(false);
                                 showDiscordInfo(false);
                                 showTelegramInfo(false);
                             }
                             if(!telegramInfo) {
                                 telegramInfoScroll();
                             }
                             showTelegramInfo(!telegramInfo);
                         }}
                    >
                        <div className="d-flex">
                            {telegramInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Telegram Integration</span>
                        </div>

                        <div className="product-block-header-optional">Optional</div>
                    </div>
                    <Collapse isOpen={telegramInfo}>
                        <Telegram telegramServerError={telegramServerError} form={form} />
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={additionalInfoRef}
                         onClick={(e) => {
                             if(e.target.tagName === 'A') {
                                 return ""
                             } else {
                                 if (isMobile) {
                                     showGeneralInfo(false);
                                     showPricingInfo(false);
                                     showProductInfo(false);
                                     showVariantsInfo(false);
                                     showPaymentInfo(false);
                                     showDiscordInfo(false);
                                     showTelegramInfo(false);
                                     showAdditionalInfo(true);
                                 }
                                 if (!additionalInfo) {
                                     additionalInfoScroll();
                                 }
                                 showAdditionalInfo(!additionalInfo);
                             }
                         }}
                    >
                        <div className="d-flex">
                            {additionalInfo ? <ChevronUp /> : <ChevronDown />}
                            <span className="d-flex">
                                Additional Details
                                <Tooltip name="extra-info" tooltipText={`Go to Products -> Utils in your sidebar to update multiple products at once.`} className="d-flex align-items-center justify-content-center color-purple">
                                    <Link to="/utils" target="_blank" className="ml-3 badge badge-paylixecommerce">
                                        <TipsIcon /> Did You Know?
                                    </Link>
                                </Tooltip>
                            </span>
                        </div>

                        <div className="product-block-header-optional">Optional</div>
                    </div>
                    <Collapse isOpen={additionalInfo}>
                        <Additional
                            form={form}
                            volumeDiscounts={volumeDiscounts}
                            setVolumeDiscounts={setVolumeDiscounts}
                            customFields={customFields}
                            setCustomFields={setCustomFields}
                            webhooks={webhooks}
                            setWebhooks={setWebhooks}
                            gateways={gateways}
                        />
                    </Collapse>
                </div>

            </form>

        </div>


        <ClosePage to="/products" open={closeConfirmModal} close={() => setShowConfirmModal(false)}/>
        <div className="edit-modal-footer">
            <Button type="button" size="large" disabled={created} variant="secondary" onClick={() => {
                if (form.dirty) {
                    setShowConfirmModal(true);
                } else {
                    history.push(isAdmin ? isAdmin : '/products');
                }
            }}>
                {form.dirty ? "Cancel" : "Close"}
            </Button>
            <Button type="submit" size="large" disabled={created} onClick={() => {
                if (variants.length < 2) {

                    if (isMobile) {
                        showVariantsInfo(true);
                    }

                    if (!variantsInfo) {
                        variantsInfoScroll();
                    }

                    setVariantsQuantityError("Must have min 2 variants")

                    showVariantsInfo(true);

                } else if(form.values.discord_integration && (!form.values.discord_server_id || form.values.discord_server_id === "none")) {
                    if (isMobile) {
                        showDiscordInfo(true);
                    }

                    if (!discordInfo) {
                        discordInfoScroll();
                    }

                    setDiscordServerError("You need to select a server if you want to use Discord");

                    showDiscordInfo(true);
                } else if(form.values.telegram_integration && (!form.values.telegram_group_id || form.values.telegram_group_id === "none")) {
                    if (isMobile) {
                        showTelegramInfo(true);
                    }

                    if (!telegramInfo) {
                        telegramInfoScroll();
                    }

                    setTelegramServerError("You need to select a group if you want to use Telegram");

                    showTelegramInfo(true);
                } else {
                    form.handleSubmit();
                }
            }}>
                {created ? <Spin2 /> : `Update Product Variant`}
            </Button>
        </div>

    </>
}

export default EditProduct;
